import { render, staticRenderFns } from "./MessageEditorDisplayer.vue?vue&type=template&id=0fd9fc01&scoped=true"
import script from "./MessageEditorDisplayer.vue?vue&type=script&lang=ts"
export * from "./MessageEditorDisplayer.vue?vue&type=script&lang=ts"
import style0 from "./MessageEditorDisplayer.vue?vue&type=style&index=0&id=0fd9fc01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd9fc01",
  null
  
)

export default component.exports